import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getBrowserRegistrationJobProgress,
    stopBrowserRegistration,
    updateUsersBrowserRegistration,
} from 'src/openapi/admin/apis/BulkUsersBrowserRegistrationApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    DEVICE_REGISTRATION_MODAL_TITLES,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    selectUpdateDeviceRegistrationTask,
    selectUpdateDeviceRegistrationUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from '../update-device-registration.slice';

import {UpdateDeviceRegistrationSettingsModal} from './update-device-registration-settings.modal';

import type {UsersBrowserRegistration} from 'src/openapi/admin/models/UsersBrowserRegistration';

type Props = {
    shown: boolean,
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const DisableDeviceRegistrationSettingsTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UsersBrowserRegistration>
            shown={shown}
            onClose={onClose}

            toolTask={TOOL_TASK}
            toolName={DEVICE_REGISTRATION_MODAL_TITLES.DISABLE_DEVICE_REGISTRATION}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateDeviceRegistrationTask}
            uuidSelector={selectUpdateDeviceRegistrationUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(usersBrowserRegistration, options) => (
                apiDispatch(updateUsersBrowserRegistration({usersBrowserRegistration, ...options}))
            )}
            getProgress={id => apiDispatch(getBrowserRegistrationJobProgress({id}))}
            stopAction={id => apiDispatch(stopBrowserRegistration({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateDeviceRegistrationSettingsModal {...{
                    userIds, onCloseModal, processAction, updateStatus: false,
                }}
                />
            )}
        </BulkActionTool>
    );
};
